export default ({ clientWrapper, context }) => ({
  schedules: () => {
    context.lastApiPath = 'no_notificate'
    return clientWrapper.api.get('/batches/schedules')
  }
})
